import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04421fc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "De enquetes hieronder worden op verschillende momenten actief. Wij zijn erg benieuwd naar uw beleving. Met een paar minuten van uw tijd kunnen wij onze diensten verder verbeteren.", -1))
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Bedankt voor uw tijd en uw mening.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Wij waarderen uw mening en zullen uw gegevens gebruiken voor het verbeteren van onze producten en diensten.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Vriendelijke groet,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Woonon")
], -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Met het invullen van deze vragenlijst helpt u ons om onze dienstverlening en producten continu te verbeteren. In geen geval geven wij informatie van dit onderzoek aan derden.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Het invullen van de vragenlijst duurt slechts enkele minuten. Wilt u deze op een later tijdstip invullen, dan is dat ook geen probleem. U vindt deze vragenlijst rechts op uw dashboard. Bedankt voor uw medewerking!", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Vriendelijke groet,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Woonon")
], -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  class: "no-mb",
  style: {"text-align":"center","line-height":"32px"}
}

import { computed, onMounted, ref } from 'vue'
import { ls } from '@/ls'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { questionnaireStore } from '@/stores/questionnaire'
import { MinusOutlined, CheckOutlined } from '@ant-design/icons-vue'
import Questionnaire from '@/types/questionnaire/questionnaire'
import axios from 'axios'
import Question from '@/components/questionnaire/Question.vue'
import { authStore } from '@/stores/auth'

export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionnaireWidget',
  setup(__props) {

dayjs.extend(isBetween)

const building = computed(() => ls.get('building'))
const showQuestionnaireModal = ref(false)
const saving = ref(false)

onMounted(() => {
  getStatus(building.value.id).then(() => {
    generateResultsData()
    popupActive()
  })
})

function getStatus (id:number) : Promise<void> {
  return new Promise((resolve) => {
    axios.get(process.env.VUE_APP_API_URL + '/questionnaires/' + id).then(r => {
      questionnaireStore().questionnaires.forEach((questionnaire) => {
        questionnaire.completed = r.data.includes(questionnaire.id)
      })
      resolve()
    })
  })
}

function generateResultsData () : void {
  for (let i = 0; i < questionnaireStore().questionnaires.length; i++) {
    const data = questionnaireStore().questionnaires[i].data
    questionnaireStore().results[i] = { id: questionnaireStore().questionnaires[i].id, answers: [] }

    for (let j = 0; j < data.questions.length; j++) {
      const question = data.questions[j]
      questionnaireStore().results[i].answers[j] = { ref: question.ref, answer: [] }
    }
  }
}

function popupActive () {
  questionnaireStore().questionnaires.forEach((questionnaire, index) => {
    if (questionnaireIsActive(questionnaire.slug) && !ls.get(questionnaire.slug + '_activated') && !showQuestionnaireModal.value) {
      showModal(index)
      ls.set(questionnaire.slug + '_activated', true)
    }
  })
}

function saveQuestionnaire () : void {
  saving.value = true

  axios.post(process.env.VUE_APP_API_URL + '/questionnaires', {
    building_id: building.value.id,
    questionnaire_id: questionnaireStore().currentQuestionnaireId,
    answers: questionnaireStore().answers
  }).finally(() => {
    questionnaireStore().markAsCompleted()
    saving.value = false
  })
}

function showModal (index:number) {
  questionnaireStore().currentQuestionnaire(index)
  showQuestionnaireModal.value = true
}

function closeModal () {
  questionnaireStore().reset()
  showQuestionnaireModal.value = false
}

function questionnaireIsActive (slug:string): boolean {
  const questionnaire = questionnaireStore().questionnaires.find(q => q.slug === slug)
  let serviceDate = null

  switch (slug) {
    default:
    case 'sales':
      return !questionnaire?.completed && building.value.sale_date !== null && dayjs().isBetween(building.value.sale_date, dayjs(building.value.sale_date).add(4, 'weeks'))
    case 'pre-selection':
      return !questionnaire?.completed && building.value.order_date !== null && dayjs().isBetween(building.value.order_date, dayjs(building.value.order_date).add(4, 'weeks'))
    case 'development':
      return !questionnaire?.completed && building.value.inspection_date !== null && dayjs().isBetween(building.value.inspection_date, dayjs(building.value.inspection_date).add(4, 'weeks'))
    case 'delivery':
      return !questionnaire?.completed && building.value.delivery_date !== null && dayjs().isBetween(dayjs(building.value.delivery_date, 'DD-MM-YYYY'), dayjs(building.value.delivery_date, 'DD-MM-YYYY').add(4, 'weeks'))
    case 'service':
      if (building.value.delivery_date === null) return false
      serviceDate = dayjs(building.value.delivery_date, 'DD-MM-YYYY').add(6, 'months')
      return !questionnaire?.completed && dayjs(serviceDate).diff(dayjs(), 'month') <= 0 && dayjs().isBetween(serviceDate, dayjs(serviceDate).add(4, 'weeks'))
  }
}

function getTooltipText (questionnaire:Questionnaire) : string {
  let tooltipText = ''

  if (!questionnaireIsActive(questionnaire.slug) && !questionnaire.completed) {
    tooltipText = 'Deze enquête is op een later moment beschikbaar.'
  } else if (questionnaire.completed) {
    tooltipText = 'Deze enquête is al door u ingevuld. Bedankt!'
  } else {
    tooltipText = 'U kunt deze enquête nu invullen.'
  }

  return tooltipText
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "Uw mening telt!" }, {
    default: _withCtx(() => [
      _hoisted_1,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(questionnaireStore)().questionnaires, (questionnaire, index) => {
        return (_openBlock(), _createBlock(_component_a_row, {
          class: "no-mb",
          key: index
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_tooltip, { placement: "left" }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTooltipText(questionnaire)), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "link",
                      disabled: !questionnaireIsActive(questionnaire.slug),
                      onClick: ($event: any) => (showModal(index))
                    }, {
                      default: _withCtx(() => [
                        (questionnaire.completed)
                          ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                              key: 0,
                              style: {"color":"#6ec618"}
                            }))
                          : (_openBlock(), _createBlock(_unref(MinusOutlined), { key: 1 })),
                        _createTextVNode(" " + _toDisplayString(questionnaire.data.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_a_modal, {
        title: _unref(questionnaireStore)().questionnaireData.title,
        width: 720,
        maskClosable: false,
        "body-style": { padding: '0', height: 'auto' },
        visible: showQuestionnaireModal.value,
        onOk: closeModal,
        onCancel: closeModal
      }, {
        footer: _withCtx(() => [
          (_unref(questionnaireStore)().started)
            ? (_openBlock(), _createBlock(_component_a_row, {
                key: 0,
                class: "no-mb"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        style: {"float":"left"},
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(questionnaireStore)().previousQuestion()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Vorige")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(questionnaireStore)().currentQuestionIndex + 1) + " van " + _toDisplayString(_unref(questionnaireStore)().numberOfQuestions), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      (!_unref(questionnaireStore)().isLastQuestion)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            disabled: _unref(questionnaireStore)().disableNext,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(questionnaireStore)().nextQuestion()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Volgende")
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : (_openBlock(), _createBlock(_component_a_button, {
                            key: 1,
                            type: "primary",
                            disabled: _unref(questionnaireStore)().disableNext || _unref(authStore)().restricted(),
                            onClick: saveQuestionnaire
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Verstuur")
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_unref(questionnaireStore)().completed)
              ? (_openBlock(), _createBlock(_component_a_row, {
                  key: 1,
                  class: "no-mb"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          onClick: closeModal,
                          type: "primary",
                          class: "col-md-offset-5 col-md-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sluiten")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_a_row, {
                  key: 2,
                  class: "no-mb"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          style: {"float":"left"},
                          onClick: closeModal
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Annuleren")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _unref(questionnaireStore)().start
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Start")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "modal-body-head",
            style: _normalizeStyle({ backgroundImage: 'url(' + _unref(questionnaireStore)().questionnaireData.image + ')', borderTop: '3px solid #f38929' })
          }, null, 4),
          (!saving.value)
            ? (_openBlock(), _createBlock(_component_a_row, {
                key: 0,
                style: {"padding":"32px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      (_unref(questionnaireStore)().started)
                        ? (_openBlock(), _createBlock(Question, { key: 0 }))
                        : (_unref(questionnaireStore)().completed)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
                          : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_a_row, {
                key: 1,
                style: {"padding":"32px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_skeleton, { active: "" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      }, 8, ["title", "visible"])
    ]),
    _: 1
  }))
}
}

})